import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestStatusGet = {
    path: "/status",
    method: RouteHttpVerb.GET
};
